import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  FilterOptionsPricingGeo,
  PaginationConfig,
  PricingGeoActions,
  PricingGeoPayload,
  PricingGeoService,
  selectPricingGeoList,
} from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { firstValueFrom, Observable } from 'rxjs';
import {
  GeoLocation,
  GeoLocationList,
  ModalService,
  PaginationService,
  ToastService,
  UtilsService,
} from 'thkee-common';
import { CommonPaginationComponent } from '../../../@shared/components/common-pagination/common-pagination.component';
import { DataTableComponent } from '../../../@shared/components/data-table/data-table.component';
const pageSize: number = 10;

@Component({
  selector: 'app-price-geolocation',
  templateUrl: './price-geolocation.component.html',
  styleUrls: ['./price-geolocation.component.scss'],
  imports: [
    RouterLink,
    AngularSvgIconModule,
    DataTableComponent,
    NgTemplateOutlet,
    CommonPaginationComponent,
    AsyncPipe,
    FormsModule,
  ],
})
export class PriceGeolocationComponent implements OnInit {
  private store = inject(Store);
  private pricingGeoService = inject(PricingGeoService);
  private readonly modalService = inject(ModalService);
  private router = inject(Router);
  private readonly toastService = inject(ToastService);
  private paginationService = inject(PaginationService);
  private activatedRoute = inject(ActivatedRoute);
  private utilsService = inject(UtilsService);

  pricingGeoList$: Observable<GeoLocationList> = this.store.select(selectPricingGeoList);
  priceGeoData: Partial<GeoLocation>[] = [];
  isLoading: Boolean = true;

  pricingGeoList: GeoLocation[] = [];
  pricingGeoPayload!: PricingGeoPayload;

  queryParams: PricingGeoPayload = { page: 1, page_size: pageSize };
  filterValues: FilterOptionsPricingGeo = {
    status: false,
  };
  filterOptions: FilterOptionsPricingGeo = {
    status: false,
  };
  isDropdown: boolean[] = [];

  ngOnInit(): void {
    this.pricingGeoPayload = {
      page: 1,
      page_size: 10,
    };
    this.queryUpdater();
    // this.store.dispatch(PricingGeoActions.loadGeoLocation(this.pricingGeoPayload));
    this.pricingGeoList$.subscribe((item) => {
      this.paginationService.getPager(item?.count, this.queryParams.page, this.queryParams.page_size);
      if (typeof item.results !== 'undefined') {
        this.pricingGeoList = item?.results || [];
      }
      this.isLoading = false;
    });
  }

  private queryUpdater() {
    firstValueFrom(this.activatedRoute.queryParams).then((params) => {
      this.queryParams.page = params['page'] ? +params['page'] : 1;
      this.queryParams.page_size = params['page_size'] ? +params['page_size'] : 10;
      this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
    });
  }

  paginationConfig: PaginationConfig = {
    pageCountSummary: true,
    pageSize: true,
    firstAndLast: true,
  };

  pageSizeAction(value: number) {
    this.isLoading = true;
    this.queryParams.page_size = value;
    this.queryParams.page = 1;
    this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
  }

  paginationAction(page_number: number) {
    this.isLoading = true;
    this.queryParams.page = page_number;
    this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
  }

  deleteConfirmation(data: GeoLocation) {
    this.modalService.confirm({
      title: 'Delete Confirmation',
      message: `Are you sure?`,
      onConfirm: () => {
        if (data.id) {
          this.pricingGeoService.deleteGeoLoc(data.id).subscribe((response) => {
            this.toastService.message({
              message: `Geolocation successfully deleted..`,
            });
            this.store.dispatch(PricingGeoActions.loadGeoLocation(this.pricingGeoPayload));
          });
        }
      },
    });
  }

  dropdown(type: number) {
    this.isDropdown[type] = !this.isDropdown[type];
  }

  filterHandler(event: Event) {
    const target = event.target as HTMLInputElement;
    this.filterOptions.status = target.checked;
    this.queryParams = { ...this.queryParams, ...this.filterOptions };
  }

  clearFilter() {
    this.filterOptions.status = false;
    delete this.queryParams.status;
    this.isDropdown[1] = false;
    this.isLoading = true;
    this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
  }

  submitFilter() {
    this.isDropdown[1] = false;
    this.isLoading = true;
    this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
  }

  search: string = '';
  searchEvent(event: Event) {
    this.isLoading = true;
    const target = event.target as HTMLInputElement;
    this.queryParams.search = target.value;
    this.queryParams.page = 1;
    this.store.dispatch(PricingGeoActions.loadGeoLocation(this.queryParams));
  }
}
